var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLoading
    ? _c("wa-element-loading", {
        staticClass:
          "display-flex flex-column flex-items-center flex-content-center",
        attrs: {
          "line-length": "md",
          content: `Loading the icon requests that have been released. Patience you must have.`,
          "custom-style": {
            "min-height": "var(--element-md-loading-min-height)",
          },
        },
      })
    : _c(
        "transition",
        {
          attrs: {
            "enter-active-class":
              "animate__animated animate__faster animate__fadeIn",
          },
        },
        [
          _c("main", { attrs: { role: "main" } }, [
            _c(
              "table",
              {
                staticClass: "roomy striped",
                attrs: {
                  summary:
                    "The most requested icons that have been released in Font Awesome",
                },
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        staticClass: "text-nowrap requests-col-sm",
                        attrs: { scope: "col" },
                      },
                      [_vm._v("\n            Status\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      { staticClass: "text-nowrap", attrs: { scope: "col" } },
                      [_vm._v("\n            Name\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-nowrap requests-col-sm",
                        attrs: { scope: "col" },
                      },
                      [
                        _c(
                          "abbr",
                          {
                            staticClass: "sr-only",
                            attrs: { title: "number" },
                          },
                          [_vm._v("\n              Number of\n            ")]
                        ),
                        _vm._v("\n            Comments\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-nowrap requests-col-sm",
                        attrs: { scope: "col" },
                      },
                      [
                        _c(
                          "abbr",
                          {
                            staticClass: "sr-only",
                            attrs: { title: "number" },
                          },
                          [_vm._v("\n              Number of\n            ")]
                        ),
                        _vm._v("\n            Reactions\n          "),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.iconRequests, function (iconRequest) {
                    return _c("requests-row", {
                      key: iconRequest.id,
                      attrs: {
                        "request-url": iconRequest.url,
                        "request-title": _vm.formattedTitle(iconRequest),
                        "request-comments-total": iconRequest.commentsTotal,
                        "request-reactions-total": iconRequest.reactionsTotal,
                        "is-released": "",
                      },
                    })
                  }),
                  1
                ),
              ]
            ),
          ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }